<template>
	<div class="source">
		<div class="group-content">
			<div class="empty" v-if="sourceList.length==0">
				<span class="msg">无相关宗源信息</span>
			</div>
			<van-swipe-cell
				v-for="(item,ind) in sourceList"
				:key="ind">

				<van-card
					:style="'margin-bottom:10px;'"
				>
					<template #title>
						<div style="font-weight:bold;">
						{{item.jishi?zongxiArrs[item.jishi-1]:''}} <span class="skin_color">{{item.name}}</span>（{{orderArrs[item.orders]}}，父：{{item.father}}）
						</div>
					</template>
					<template #desc>
						<div style="padding:10px 0px; line-height:22px;">
						<div v-if="item.jishi_note">{{item.jishi_note}}</div>
						{{item.content||''}}
						</div>
					</template>
					<template #num>
						{{item.zihao}}
					</template>
					<template #price>
						{{item.birth_note}}
					</template>
				</van-card>

				<template #right>
					<van-button square text="编辑" type="primary" @click="onEditSource(item.id)"/>
					<van-button square text="子嗣" type="primary" @click="onEditSourceChild(item.id)"/>
					<van-button square text="创建族谱" type="info" @click="onAddPedigree" v-if="!$parent.$parent.infoAuth.personal_id"/>
					<van-button square text="删除" type="danger" @click="onDelSource(item.id)"/>
				</template>

			</van-swipe-cell>
		</div>

		<van-popup v-model="showEditSource" round position="bottom" :style="{ 'max-height': '80%', 'bottom':'50px' }">
			<van-cell-group > 
				<van-field
					v-model.trim="sourceInfo.name"
					label="名字："
					required
					placeholder="请输入名字"
					clearable
				></van-field>
				<van-cell
					@click="showPickers(1,-1)"
					title="宗系："
					is-link
					:value="jishiStr"
					required
					title-class="van-cell-title"
				></van-cell>
				<van-field
					v-model.trim="sourceInfo.jishi_note"
					label="宗系简要："
					placeholder="请输入宗系简要"
					clearable
				></van-field>
				<van-field
					v-model.trim="sourceInfo.zihao"
					label="字号："
					placeholder="请输入字号"
					clearable
				></van-field>
				<van-field
					v-model.trim="sourceInfo.birth_note"
					label="生平简要："
					placeholder="请输入生平简要"
					required
					clearable
				></van-field>
				<van-field
					v-model.trim="sourceInfo.father"
					label="父亲名字："
					placeholder="请输入父亲名字"
					required
					clearable
				></van-field>
				<van-cell
					@click="showPickers(2,-1)"
					title="家庭排行："
					is-link
					:value="orderStr"
					required
					title-class="van-cell-title"
				></van-cell>
				<van-field
				  v-model.trim="sourceInfo.content"
				  rows="3"
				  autosize
				  label="家庭简要："
				  type="textarea"
				  maxlength="3000"
				  placeholder="请输入简要内容"
				  show-word-limit
				/>

				<van-row  :style="{'margin-bottom':'10px'}">
					<van-col span="1"></van-col>
					<van-col span="9">
						<van-button type="default" block  @click="showEditSource=false">取消</van-button>
					</van-col>
					<van-col span="1"></van-col>
					<van-col span="12">
						<van-button type="primary" block  @click="onSaveSource">保存</van-button>
					</van-col>
					<van-col span="1"></van-col>
				</van-row> 

			</van-cell-group>
		</van-popup>


		<van-popup v-model="showPicker" position="bottom">
		  <van-picker
			show-toolbar
			title="请选择"
			:columns="pickerColumns"
			@cancel="showPicker = false"
			@confirm="onConfirmPicker"
		  />
		</van-popup>

		<van-button square text="新增" type="default" class="btn_add" @click="onAddSource"/>

		<van-popup v-model="showEditSourceChild" round position="bottom" closeable close-icon="close" :style="{ 'max-height': '80%', 'bottom':'50px','padding-top':'40px' }">
			<van-row  :style="{'margin-bottom':'10px'}">
				<van-col span="8" style="font-weight:bold;">名字</van-col>
				<van-col span="8" style="font-weight:bold;">排行</van-col>
				<van-col span="8" style="font-weight:bold;">双承</van-col>
			</van-row> 
			<van-row v-for="(item,ind) in sourceChildList" :key="ind"> 
				<van-col span="8">
					<van-field
						v-model.trim="item.name"
						label=""
						placeholder="请输入"
						clearable
					></van-field>
				</van-col>
				<van-col span="8">
				<van-cell
					@click="showPickers(3,ind)"
					title=""
					is-link
					:value="item.orders?orderArrs[item.orders]:'请选择'"
					title-class="van-cell-title"
				></van-cell>
				</van-col>
				<van-col span="8">
					<van-field
						v-model.trim="item.adpot"
						label=""
						placeholder="请输入"
						clearable
					></van-field>
				</van-col>
			</van-row>

			<van-row  :style="{'margin-bottom':'10px'}">
				<van-col span="1"></van-col>
				<van-col span="9">
					<van-button type="default" block  @click="onAddSourceChild">新增</van-button>
				</van-col>
				<van-col span="1"></van-col>
				<van-col span="12">
					<van-button type="primary" block  @click="onSaveSourceChild">保存</van-button>
				</van-col>
				<van-col span="1"></van-col>
			</van-row> 
		</van-popup>

	</div>
</template>

<script>
import {Card, SwipeCell } from "vant";
import {num2chinese } from "@/utils/common.js";

export default {
	name: "pedigree-source",
	components: {
		"van-card":Card,
		"van-swipe-cell":SwipeCell
	},
	props:{
		pedigree_id:String,
		pedigree_num:String
	},
	data() {
		return {
			title: "宗源信息",
			u_id: localStorage.getItem("u_id"),
			token: localStorage.getItem(localStorage.getItem("u_id") + "token"),

			sourceList:[],
			sourceInfoObj:{},
			showEditSource:false,
			sourceInfo:{},
			saveFlag:false,

			showPicker:false,
			showPickerType:0,
			pickerColumns:[],
			jishiStr:'请选择',
			orderStr:'请选择',

			showEditSourceChild:false,
			editSourceId:0,
			sourceChildList:[],
			editSourceInd:-1

		};
	},
	created() {
		this.getSourceData();
	},
	computed: {
		zongxiArrs:function(){
			let zxArr = ['始祖'];
			for(var i=2;i<101;i++){
				zxArr.push('第'+num2chinese(i)+'世')
			}
			return zxArr;
		},
		orderArrs:function(){
			let xdArr = ['未知','长子','次子'];
			for(var i=3;i<101;i++){
				xdArr.push(num2chinese(i)+'子')
			}
			return xdArr;
		}
	},
	methods: {
		showPickers(t, i){
			this.showPickerType=t;
			if(t==1){
				this.pickerColumns = this.zongxiArrs;
			}
			if(t==2 || t==3){
				this.pickerColumns = this.orderArrs;
			}
			this.editSourceInd = i;
			this.showPicker = true;
		},
		onConfirmPicker(value, indexs){
			if(this.showPickerType==1){
				this.jishiStr = value;
				this.sourceInfo.jishi = indexs+1;
			}
			if(this.showPickerType==2){
				this.orderStr = value;
				this.sourceInfo.orders = indexs;
			}
			if(this.showPickerType==3){
				this.sourceChildList[this.editSourceInd].orders = indexs;
			}
			this.showPicker = false;
		},
		getSourceData(){
			var params = {
				u_id:this.u_id,
				token:this.token,
				p_id:this.pedigree_id,
				p_num:this.pedigree_num,
			};
			let that = this;
			var url = this.Conf.serverUrl + "clans/pedigreeSource" + "?num="+Math.random();
			this.$axios
			.post(url, this.$qs.stringify(params))
			.then(response => {
				that.sourceList = [];
				that.sourceInfoObj = {};
				let edus = response.data.datas;
				if(edus && edus.length > 0){
					that.sourceList = edus;
					for(var i=0,il=edus.length; i<il; i++){
						that.sourceInfoObj[edus[i]['id']] = edus[i];
					};
				}
			})
			.catch(error => {});
		},
		onAddSource(){
			this.sourceInfo = {pedigree_num:this.pedigree_num,orders:0};
			this.showEditSource = true;
		},
		onEditSource(id){
			this.sourceInfo = this.sourceInfoObj[id];
			this.showEditSource = true;
		},
		onDelSource(id){
			this.$dialog
			.confirm({
				title: "温馨提醒",
				message: "删除后将不可恢复，确定？",
			})
			.then(() => {
				var params = {
					u_id:this.u_id,
					token:this.token,
					id:id
				};
				let that = this;
				var url = this.Conf.serverUrl + "clans/pedigreeSourceDel" + "?num="+Math.random();
				this.$axios
				.post(url, this.$qs.stringify(params))
				.then(response => {
					that.$toast.success(response.data.msg);
					if(response.data.code == 200){
						that.getSourceData();
					}
				})
				.catch(error => {});
			})
			.catch((error) => {});
		},
		onSaveSource(){
			if(this.saveFlag){
				this.$toast.fail("请求尚未响应，请勿重复提交！");
				return false;
			}
			if(!this.sourceInfo['name']){
				this.$toast.fail("请输入名字！");
				return false;
			}
			if(this.jishiStr == '请选择'){
				this.$toast.fail("请选择宗系！");
				return false;
			}
			if(!this.sourceInfo['birth_note']){
				this.$toast.fail("请输入生平简要！");
				return false;
			}
			if(!this.sourceInfo['father']){
				this.$toast.fail("请输入父亲名字！");
				return false;
			}
			if(this.orderStr == '请选择'){
				this.$toast.fail("请选择排行！");
				return false;
			}
			
			this.saveFlag = true;
			var params = {
				u_id:this.u_id,
				token:this.token,
				data:this.sourceInfo
			};
			let that = this;
			var url = this.Conf.serverUrl + "clans/pedigreeSourceSave" + "?num="+Math.random();
			this.$axios
			.post(url, this.$qs.stringify(params))
			.then(response => {
				that.saveFlag = false;
				that.$toast.success(response.data.msg);
				if(response.data.code == 200){
					that.getSourceData();
					that.showSourceTimePopup = false;
					that.showEditSource = false;
				}
			})
			.catch(error => {});
		},
		onEditSourceChild(sid){
			this.editSourceId = sid;
			this.showEditSourceChild = true;
			var params = {
				u_id:this.u_id,
				token:this.token,
				s_id:sid,
			};
			let that = this;
			var url = this.Conf.serverUrl + "clans/pedigreeSourceChild" + "?num="+Math.random();
			this.$axios
			.post(url, this.$qs.stringify(params))
			.then(response => {
				that.sourceChildList = response.data.datas;
			})
			.catch(error => {});
		},
		onAddSourceChild(){
			this.sourceChildList.push({source_id:this.editSourceId});
		},
		onSaveSourceChild(){
			console.log(this.sourceChildList)
			if(this.saveFlag){
				this.$toast.fail("请求尚未响应，请勿重复提交！");
				return false;
			}
			if(this.sourceChildList.length > 0){
				for(var i=0,il=this.sourceChildList.length; i<il; i++){
					if(!this.sourceChildList[i]['name'] || !this.sourceChildList[i]['orders']){
						this.$toast.fail("请检查名字和排行是否完整！");
						return false;
					}
				}
			}
			this.saveFlag = true;
			var params = {
				u_id:this.u_id,
				token:this.token,
				s_id:this.editSourceId,
				data:this.sourceChildList
			};
			let that = this;
			var url = this.Conf.serverUrl + "clans/pedigreeSourceChildSave" + "?num="+Math.random();
			this.$axios
			.post(url, this.$qs.stringify(params))
			.then(response => {
				that.saveFlag = false;
				that.$toast.success(response.data.msg);
				if(response.data.code == 200){
					that.showEditSourceChild = false;
				}
			})
			.catch(error => {});
		},
		onAddPedigree(){
			this.$parent.$parent.onAddParentPedigree();
		}
	}
};
</script>



// WEBPACK FOOTER //
// src/components/Clans/PedigreeSource.vue